import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-52455378"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "TagGroup" }
const _hoisted_2 = { class: "TagCard" }
const _hoisted_3 = { class: "TagCard-img-container" }
const _hoisted_4 = ["src", "alt"]
const _hoisted_5 = { class: "Text" }


export default /*#__PURE__*/_defineComponent({
  __name: 'TimeLine',
  setup(__props) {

const activities = [
  {
    timestamp: "2023-08",
    color: "#a58037",
    img: require("@/assets/HKUST.png"),
    title: "香港科技大学",
    desc: "CSE Dept.",
    motto: "先驅新進 求變無間 東西春秋 日月可鑑",
  },
  {
    timestamp: "2019-10",
    color: "#b90203",
    img: require("@/assets/同济大学学生会.png"),
    title: "同济大学学生会",
    desc: "采写编辑部",
    motto: "自觉觉人",
  },
  {
    timestamp: "2019-08",
    color: "#0059aa",
    img: require("@/assets/tongji.png"),
    title: "同济大学",
    desc: "软件学院",
    motto: "夫吴人与越人相恶也,当其同舟而济,遇风,其相救也,如左右手",
  },
  {
    timestamp: "2016-09",
    color: "#d41920",
    img: require("@/assets/Kangjie_Middle_School_Logo.png"),
    title: "康杰中学",
    desc: "",
    motto: "问渠那得清如许,为有源头活水来",
  },
];

return (_ctx: any,_cache: any) => {
  const _component_el_timeline_item = _resolveComponent("el-timeline-item")!
  const _component_el_timeline = _resolveComponent("el-timeline")!

  return (_openBlock(), _createBlock(_component_el_timeline, null, {
    default: _withCtx(() => [
      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(activities, (activity, index) => {
        return _createVNode(_component_el_timeline_item, {
          key: index,
          color: activity.color,
          timestamp: activity.timestamp,
          placement: "top",
          size: "large"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("img", {
                    src: activity.img,
                    alt: activity.title
                  }, null, 8, _hoisted_4)
                ]),
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("h1", null, _toDisplayString(activity.title), 1),
                  _createElementVNode("p", null, [
                    _createElementVNode("strong", null, _toDisplayString(activity.desc), 1)
                  ]),
                  _createElementVNode("p", null, _toDisplayString(activity.motto), 1)
                ])
              ])
            ])
          ]),
          _: 2
        }, 1032, ["color", "timestamp"])
      }), 64))
    ]),
    _: 1
  }))
}
}

})